import { PACKAGE_PLANS } from "../../helpers/constants/url";
import baseApi from "./baseApiEndpoints";

// Define a service using a base URL and expected endpoints
export const packagePlansApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPackagePlans: builder.query({
      query: () => `${PACKAGE_PLANS}`,
      providesTags: ["PackagePlan"],
    })
  }),
  overrideExisting: false,
});

export const { useGetAllPackagePlansQuery } = packagePlansApi;
